import api from "./httpClientInstance";
import API_ENDPOINTS from "../config/Endpoints";

/**
 * Submit new feedback (one per user).
 * @param {{ rating: number, feedback_message: string }} data
 * @returns {Promise<Object>} 201 response with created feedback.
 */
export const submitFeedback = async (data) => {
    const response = await api.post(API_ENDPOINTS.FEEDBACK, {
        ...data,
        source: "web",
    });
    return response;
};

/**
 * Retrieve the logged-in user's existing feedback.
 * @returns {Promise<Object>} 200 response with feedback results.
 */
export const getFeedback = async () => {
    const response = await api.get(API_ENDPOINTS.FEEDBACK);
    return response;
};

/**
 * Update an existing feedback entry (partial updates supported).
 * @param {{ rating?: number, feedback_message?: string }} data
 * @returns {Promise<Object>} 200 response with updated feedback.
 */
export const updateFeedback = async (data) => {
    const response = await api.put(API_ENDPOINTS.FEEDBACK, data);
    return response;
};
